import Vue from "vue";
import VueI18n from "vue-i18n";

import { I18nHelpers } from "@/helpers/i18n";
import axios from "axios";

const TRANSLATION_URI = location.href.indexOf("test.tms.pl") > -1 || location.href.indexOf("localhost") > -1
  ? "https://master-proxy.test.tms.pl/api/translations/get?service=onboarding&lang="
  : "https://proxy.tms.pl/api/translations/get?service=onboarding&lang=";

Vue.use(VueI18n);

const appLocale = I18nHelpers.getAppLocale();

const i18n = new VueI18n({
  locale: appLocale,
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || "en",
  messages: {},
});

export async function loadLocaleMessagesAsync(locale: string) {
  if (I18nHelpers.isExpired(locale) || !I18nHelpers.isSet(locale)) {
    const messages = await axios.get(`${TRANSLATION_URI}${locale}`);
    try {
      i18n.setLocaleMessage(locale, messages.data);

      I18nHelpers.setLocaleTranslation(locale, messages.data);

      I18nHelpers.setLocaleTimestamp(locale);

      i18n.locale = locale;
    } catch (error) {
      console.error(error);

      i18n.setLocaleMessage(locale, I18nHelpers.loadLocaleTranslation(locale));
      i18n.locale = locale;
    }
  } else {
    i18n.setLocaleMessage(locale, I18nHelpers.loadLocaleTranslation(locale));
    i18n.locale = locale;
  }
  return locale;
}

export default i18n;
